import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { DatePipe, HashLocationStrategy, LocationStrategy, registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeFr from '@angular/common/locales/fr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing';
import { AppComponent } from './app.component';
import { AuthenticationModule } from './authentication/authentication.module';
import { AuthenticationService } from './authentication/authentication.service';
import { TokenInterceptor } from './authentication/interceptors/authentication.interceptor';
import { ComponentsModule } from './components/components.module';
import { DashboardModule } from './dashboard/dashboard.module';
import { DemandResolver } from './dashboard/demands/components/demand/demand.resolver';
import { DownloadModule } from './download/download.module';
import { ErrorRoutingModule } from './shared/errors/errors-routing.module';
import { ServerErrorsInterceptor } from './shared/errors/interceptors/server-errors.interceptor';
import { HelpersModule } from './shared/helpers/helpers.module';
import { UserResolver } from './shared/helpers/user.resolver';
import { ContractsService } from './shared/services/contracts.service';
import { ServicesModule } from './shared/services/services.module';
import { UserService } from './shared/services/user/user.service';
import { TextInputDialogComponent } from './components/modals/text-input-dialog-modal/text-input-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';


registerLocaleData(localeFr, 'fr');

@NgModule({
  declarations: [
    AppComponent,
    TextInputDialogComponent,
  ],
  imports: [
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    DashboardModule,
    HelpersModule,
    DownloadModule,
    ServicesModule,
    AppRoutingModule,
    AuthenticationModule,
    ErrorRoutingModule,
    ComponentsModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule
  ],
  providers: [
    AuthenticationService,
    ContractsService,
    UserService,
    DemandResolver,
    UserResolver,
    DatePipe,
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ServerErrorsInterceptor, multi: true },
    {provide: LocationStrategy, useClass: HashLocationStrategy},
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}

declare global {
  interface StringConstructor {
    removeAccents(value): string;
  }
}

String.removeAccents = function(value: string): string {
  if (!value) return;

  var accent = [
    /[\300-\306]/g,
    /[\340-\346]/g, // A, a
    /[\310-\313]/g,
    /[\350-\353]/g, // E, e
    /[\314-\317]/g,
    /[\354-\357]/g, // I, i
    /[\322-\330]/g,
    /[\362-\370]/g, // O, o
    /[\331-\334]/g,
    /[\371-\374]/g, // U, u
    /[\321]/g,
    /[\361]/g, // N, n
    /[\307]/g,
    /[\347]/g // C, c
  ];
  var noaccent = ["A", "a", "E", "e", "I", "i", "O", "o", "U", "u", "N", "n", "C", "c"];

  var str = value;
  for (var i = 0; i < accent.length; i++) {
    str = str.replace(accent[i], noaccent[i]);
  }

  return str;
};
